(function () {
  /**
   * @ngdoc directive
   * @name appRequireFeature
   * @description
   * Feature markup directly within views without requiring controller support.
   * Element included if requireFeature flag is enabled.
   * For example: <p app-require-feature="enabledFlag">Show this paragraph.</p>
   */
  angular.module('app.widgets.common.feature').directive('appRequireFeature', requireFeature);

  function requireFeature(feature) {
    return {
      link: (scope, element, attrs) => {
        if (feature.isDisabled(attrs.appRequireFeature)) {
          element.remove();
        }
      },
      restrict: 'A',
    };
  }
})();
